import React from 'react';

import PropTypes from 'prop-types';

const FieldHint = ({ hint }) => {
    if (!hint) return null;

    return (
        <div className="ml-form-field-helptext">
            { hint }
        </div>
    );
};

FieldHint.propTypes = {
    hint: PropTypes.string,
};

export default FieldHint;
